<template>
  <div class="w-full overflow-hidden rounded">
    <table class="w-full text-sm" v-if="authorizations.length">
      <thead>
        <tr>
          <th v-for="head in tableHead" :key="head.label" class="bg-ontick-steel-500 p-2">
            <div v-if="head.visible" class="text-left">
              <span>
                {{ head.label }}
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="auth in authorizations"
          :key="auth.aut_id"
          class="bg-ontick-graphite-500 overflow-hidden last:rounded-b"
        >
          <td>
            <div class="flex items-center justify-center gap-2">
              <div class="relative">
                <div class="bg-ontick-green-600 absolute top-0 left-0 h-3 w-3 animate-ping rounded-full"></div>
                <div class="bg-ontick-green-600 h-3 w-3 rounded-full"></div>
              </div>
              <ontick-switch :active="auth.aut_status === 'ACTIVE'" @switch="disableDialog(auth.aut_id)" />
            </div>
          </td>
          <td>
            <span>
              {{ auth.aut_id }}
            </span>
          </td>
          <td>
            <div class="flex items-center gap-2">
              <div>
                <ontick-broker-logo-component :broker="auth.broker_name" />
              </div>
              <span class="text-gray-200">
                {{ auth.broker_name }}
              </span>
              <span class="text-gray-400"> (#{{ auth.account_number }}) </span>
            </div>
          </td>
          <td>
            <span>
              {{ auth.partner_name }}
            </span>
          </td>
          <td>
            <span>
              {{ auth.strategy_name }}
            </span>
          </td>
          <td>
            <span>
              {{ auth.strategy_analyst }}
            </span>
          </td>
          <!-- <td>
            <span>
              {{ auth.user_max_positions }}
            </span>
          </td> -->
          <td>
            <span>
              {{ auth.user_max_exposure | currency }}
            </span>
          </td>

          <td>
            <span>
              {{ moment(auth.aut_create_date).format("DD/MM/YYYY HH:mm:ss") }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else class="flex items-center justify-center py-12">
      <p class="text-lg font-bold">Nenhuma pré-autorização encontrada.</p>
    </div>
    <portal to="modal">
      <ontick-modal-component
        :open="disableModalIsActive"
        :showCloseButton="false"
        @close="disableModalIsActive = false"
        size="small"
      >
        <div class="divide-ontick-steel-500 flex flex-col divide-y-2 px-4">
          <div class="flex flex-col items-center gap-2 pb-4">
            <i>
              <svg width="104" height="104" viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M52 73.6667C53.2278 73.6667 54.2569 73.2515 55.0875 72.4209C55.9181 71.5904 56.3333 70.5612 56.3333 69.3334C56.3333 68.1056 55.9181 67.0765 55.0875 66.2459C54.2569 65.4154 53.2278 65.0001 52 65.0001C50.7722 65.0001 49.7431 65.4154 48.9125 66.2459C48.0819 67.0765 47.6667 68.1056 47.6667 69.3334C47.6667 70.5612 48.0819 71.5904 48.9125 72.4209C49.7431 73.2515 50.7722 73.6667 52 73.6667ZM52 56.3334C53.2278 56.3334 54.2569 55.9181 55.0875 55.0876C55.9181 54.257 56.3333 53.2279 56.3333 52.0001V34.6667C56.3333 33.439 55.9181 32.4098 55.0875 31.5792C54.2569 30.7487 53.2278 30.3334 52 30.3334C50.7722 30.3334 49.7431 30.7487 48.9125 31.5792C48.0819 32.4098 47.6667 33.439 47.6667 34.6667V52.0001C47.6667 53.2279 48.0819 54.257 48.9125 55.0876C49.7431 55.9181 50.7722 56.3334 52 56.3334ZM52 95.3334C46.0056 95.3334 40.3722 94.1959 35.1 91.9209C29.8278 89.6459 25.2417 86.5584 21.3417 82.6584C17.4417 78.7584 14.3542 74.1723 12.0792 68.9001C9.80417 63.6279 8.66667 57.9945 8.66667 52.0001C8.66667 46.0056 9.80417 40.3723 12.0792 35.1001C14.3542 29.8279 17.4417 25.2417 21.3417 21.3417C25.2417 17.4417 29.8278 14.3542 35.1 12.0792C40.3722 9.80425 46.0056 8.66675 52 8.66675C57.9944 8.66675 63.6278 9.80425 68.9 12.0792C74.1722 14.3542 78.7583 17.4417 82.6583 21.3417C86.5583 25.2417 89.6458 29.8279 91.9208 35.1001C94.1958 40.3723 95.3333 46.0056 95.3333 52.0001C95.3333 57.9945 94.1958 63.6279 91.9208 68.9001C89.6458 74.1723 86.5583 78.7584 82.6583 82.6584C78.7583 86.5584 74.1722 89.6459 68.9 91.9209C63.6278 94.1959 57.9944 95.3334 52 95.3334Z"
                  fill="#DD5B5B"
                />
              </svg>
            </i>
            <p class="text-3xl">Cancelar pré autorização</p>
          </div>
          <div class="flex flex-col items-center gap-4 pt-4 text-center">
            <p class="text-gray-400">
              Para cancelar esta pré autorização digite a palavra
              <span class="font-bold text-gray-300">CANCELAR</span> no campo abaixo.
            </p>
            <input
              type="text"
              :value="confirmationText"
              @input="confirmationText = $event.target.value.toUpperCase()"
              class="bg-ontick-carbon-500 h-10 w-full rounded border-none text-center"
              placeholder="Escreva aqui"
            />
            <button
              @click="disableAuth(idToDisable)"
              :disabled="!allowDisable"
              class="bg-ontick-red-700 disabled:bg-ontick-steel-500 w-full rounded-md py-2 text-lg font-bold uppercase filter transition-all hover:brightness-125 disabled:cursor-not-allowed disabled:text-gray-500 disabled:filter-none"
            >
              Confirmar
            </button>
          </div>
        </div>
      </ontick-modal-component>
    </portal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ontickBrokerLogoComponent from "../../../shared/components/basic/ontick-broker-logo.component.vue";
import OntickModalComponent from "../../../shared/components/basic/ontick-modal.component.vue";
export default {
  components: {
    ontickBrokerLogoComponent,
    OntickModalComponent,
  },

  props: {
    authorizations: {
      type: Array,
    },
    tableHead: {
      type: Array,
    },
  },

  data() {
    return {
      idToDisable: "",
      disableModalIsActive: false,
      confirmationText: "",
    };
  },

  computed: {
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
    allowDisable() {
      return this.confirmationText === "CANCELAR";
    },
  },

  methods: {
    disableAuth(aut_id) {
      this.$api
        .post(this.$endpoint.AUTH_DISABLE, {
          account_id: this.getSelectedAccount.account_id,
          aut_id,
        })
        .then((res) => {
          // console.log(res);
          this.$swal("Sucesso", this.$filters.capitalize(res.data.msg), "success");
          this.$emit("reload");
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", this.$filters.capitalize(err.data.msg), "error");
        })
        .finally(() => {
          this.confirmationText = "";
          this.disableModalIsActive = false;
        });
    },
    disableDialog(aut_id) {
      this.idToDisable = aut_id;
      this.disableModalIsActive = true;
    },
  },
};
</script>

<style lang="scss" scoped>
tbody {
  td {
    @apply py-3 px-2;
  }
}
</style>
